<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-xlg-3 col-md-5">
                <div class="card">
                    <div class="card-body text-center">
                        <div class="profile-pic m-b-20 m-t-20">
                            <blockie :address="this.currentUser.email" style="width: 150px"></blockie>
                            <!--<img src="../../../assets/images/users/1.jpg" width="150" class="rounded-circle" alt="user" />-->
                            <h4 class="m-t-20 m-b-0"></h4>
                            <a>{{user.email}}</a>
                        </div>
                    </div>
                    <div class="p-25 border-top m-t-15">
                        <div class="row text-center">
                            <div class="col-6 border-right">
                                <router-link :to="{ name: 'editprofile'}" class="link d-flex align-items-center justify-content-center font-medium">
                                    <i class="mdi mdi-account font-20 m-r-5"></i>&nbsp;Edit Profile
                                </router-link>
                            </div>
                            <div class="col-6">
                                <router-link :to="{name: 'wallet'}" class="link d-flex align-items-center justify-content-center font-medium">
                                    <i class="mdi mdi-bank font-20 m-r-5"></i>&nbsp;Banking
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-xlg-9 col-md-7">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Your Profile</h4>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'viewprofile'}" class="btn btn-outline-secondary waves-effect waves-light"><i class="fas fa-arrow-circle-left"></i> Back</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue">
                        <form class="form-horizontal">
                            <div class="card-body">
                                <h4 class="card-title">Personal Info</h4>
                                <div class="form-group row">
                                    <label for="first_name" class="col-sm-3 text-right control-label col-form-label">First Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="first_name" placeholder="First Name Here" v-model="user.first_name">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="last_name" class="col-sm-3 text-right control-label col-form-label">Last Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="last_name" placeholder="Last Name Here" v-model="user.last_name">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-3 text-right control-label col-form-label">Email</label>
                                    <div class="col-sm-9">
                                        <input type="email" class="form-control" id="email" placeholder="Email Here" disabled v-model="user.email">
                                    </div>
                                </div>
                                <!--<div class="form-group row">-->
                                <!--<label for="cono1" class="col-sm-3 text-right control-label col-form-label">Contact No</label>-->
                                <!--<div class="col-sm-9">-->
                                <!--<input type="text" class="form-control" id="cono1" placeholder="Contact No Here">-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>
                            <hr>
                            <div class="card-body">
                                <h4 class="card-title">Address</h4>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="line1" class="col-sm-3 text-right control-label col-form-label">Line 1</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="line1" v-model="address.line1" placeholder="Address Line 1">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="line2" class="col-sm-3 text-right control-label col-form-label">Line 2</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="line2" v-model="address.line2" placeholder="Address Line 2">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="city" class="col-sm-3 text-right control-label col-form-label">City</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="city" v-model="address.city" placeholder="City">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="state" class="col-sm-3 text-right control-label col-form-label">State</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="state" v-model="address.state" placeholder="State">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="postal_code" class="col-sm-3 text-right control-label col-form-label">Postal Code</label>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="postal_code" v-model="address.postal_code" placeholder="Postal Code">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="country" class="col-sm-3 text-right control-label col-form-label">Country</label>
                                    <div class="col-sm-5">
                                        <multiselect id="country"
                                                     name="country"
                                                     class="form-control multiselect-sm"
                                                     v-model="selectedCountry"
                                                     :options="countries"
                                                     label="name"
                                                     placeholder="Country"
                                                     data-vv-as="Country"
                                                     track-by="code">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <div class="form-group m-b-0 text-right">
                            <div class="button-group">
                                <button type="button" class="btn waves-effect waves-light btn-success" @click="save()">Save</button>
                                <button type="button" @click="reset()" class="btn waves-effect waves-light btn-secondary">Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from '../common/Blockie';
    import Multiselect from 'vue-multiselect';
    import countries from "../../../assets/js/countries";

    export default {
        name: "MyProfile",
        computed: {
            ...mapGetters(["currentUser"])
        },
        components: {Blockie, Multiselect},
        data() {
            return {
                countries: countries,
                selectedCountry: {
                    code: '',
                    name: ''
                },
                user: {
                    first_name: '',
                    last_name: '',
                    email: '',
                },
                address: {
                    id: null,
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: '',
                    country_code: ''
                }
            }
        },
        mounted() {
            this.getUser();
        },
        methods: {
            async getUser() {
                let reply                 = await this.$http.get('/account');
                this.user.first_name      = reply.data.first_name;
                this.user.last_name       = reply.data.last_name;
                this.user.email           = reply.data.email;
                this.address.id           = reply.data.address_id;
                this.address.line1        = reply.data.line1;
                this.address.line2        = reply.data.line2;
                this.address.city         = reply.data.city;
                this.address.state        = reply.data.state;
                this.address.postal_code   = reply.data.postal_code;
                this.selectedCountry.code = reply.data.country_code;
                this.selectedCountry.name = reply.data.country;
            },
            handleOnchange() {
            },
            async save() {
                this.address.country      = this.selectedCountry.name;
                this.address.country_code = this.selectedCountry.code;
                let payload               = {
                    user: this.user,
                    address: this.address
                };
                try {
                    let reply = await this.$http.post('/account', payload);
                    this.$toastr('success', 'Profile details updated', 'Updated');
                    this.getUser();
                } catch(e) {
                    this.$toastr('error', 'Profile details could not be updated', 'Failed');
                }

            },
            async reset() {
                this.getUser();
            }
        }
    }
</script>

<style scoped>

</style>
